import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import * as InlineEditor from '@ckeditor/ckeditor5-build-inline';
import { EmailTemplate } from 'src/app/models/EmailTemplateModel';

@Component({
  selector: 'cw-ci-email-template-edit',
  templateUrl: './email-template-edit.component.html',
  styleUrls: ['./email-template-edit.component.scss']
})
export class EmailTemplateEditComponent implements OnInit {
  public Editor = InlineEditor;

  _emailTemplate: EmailTemplate;

  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  @Input() set emailTemplate(value: EmailTemplate) {
    this._emailTemplate = value;
    this.emailTemplateForm.reset();
    if (this._emailTemplate.id) {
      this.emailTemplateForm.controls.type.setValue(this._emailTemplate.type);
      this.emailTemplateForm.controls.theme.setValue(this._emailTemplate.theme);
      this.emailTemplateForm.controls.subject.setValue(this._emailTemplate.subject);
      this.emailTemplateForm.controls.sender.setValue(this._emailTemplate.sender);
      this.emailTemplateForm.controls.htmlBody.setValue(this._emailTemplate.htmlBody);
      this.emailTemplateForm.controls.textBody.setValue(this._emailTemplate.textBody);
    }
  }

  emailTemplateForm = new FormGroup ({
    type: new FormControl('', [Validators.required]),
    theme: new FormControl('', [Validators.required]),
    subject: new FormControl('', [Validators.required]),
    sender: new FormControl('', [Validators.required]),
    htmlBody: new FormControl('', [Validators.required]),
    textBody: new FormControl('', [Validators.required]),
  });

  constructor(private _platformApi: PlatformApiService) { }

  ngOnInit() {
  }

  saveEmailTemplate() {
    if (this.emailTemplateForm.valid) {
      const saveTmpl = new EmailTemplate({
        type: this.emailTemplateForm.value.type,
        theme: this.emailTemplateForm.value.theme,
        subject: this.emailTemplateForm.value.subject,
        sender: this.emailTemplateForm.value.sender,
        htmlBody: this.emailTemplateForm.value.htmlBody,
        textBody: this.emailTemplateForm.value.textBody,
      });
      if (this._emailTemplate.id) {
        saveTmpl.id = this._emailTemplate.id;
      }

      this._platformApi.saveEmailTemplate(saveTmpl).subscribe(
        resp => {
          this.stateChange.emit({state: 'CREATESUCCESS'})
        }
      );
    }
  }

  cancel() {
    this.emailTemplateForm.reset();
    this.stateChange.emit({state: 'EDITCANCEL'});
  }
}
